import axios from "axios";
import Config from "../config/config.js";
import { getCurrentSessionKey } from "../context/AuthContext.js";

var headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${Config.server.apiKey}`
}

if (Config.server.environment === "development") {
  headers["X-real-ip"] = "84.203.106.59";
}

const api = axios.create({
  baseURL: Config.server.baseUrl,
  headers: headers,
});

function checkSession() {
  var sessionKey = getCurrentSessionKey();
  if (sessionKey && sessionKey !== "null") {
    api.defaults.headers.common["x-rqt-session-id"] = sessionKey;
  }  else {
    delete api.defaults.headers.common["x-rqt-session-id"];
  }
}

export const postData = async(endpoint, payload, extra) => {
  try {
    checkSession();
    extra = typeof extra === "object" ? extra : {};
    const response = await api.post(`/${endpoint}`, payload, extra);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const patchData = async(endpoint, payload, extra) => {
  try {
    checkSession();
    extra = typeof extra === "object" ? extra : {};
    const response = await api.patch(`/${endpoint}`, payload, extra);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const putData = async(endpoint, payload, extra) => {
  try {
    checkSession();
    extra = typeof extra === "object" ? extra : {};
    const response = await api.put(`/${endpoint}`, payload, extra);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteData = async(endpoint, payload) => {
  try {
    checkSession();
    const config = payload !== undefined ? { data: payload } : undefined;
    const response = await api.delete(`/${endpoint}`, config);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const fetchData = async (endpoint, extra) => {
  try {
    checkSession();
    extra = typeof extra === "object" ? extra : {};
    const response = await api.get(`/${endpoint}`, extra);
    return response.data;
  } catch (error) {
    throw error;
  }
};